import { render, staticRenderFns } from "./mailchimpEmbed.vue?vue&type=template&id=18fb6aee&"
import script from "./mailchimpEmbed.vue?vue&type=script&lang=js&"
export * from "./mailchimpEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports